import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FILE_API_SERVICE_TOKEN } from '@nk/api-lib';
import { of } from 'rxjs';

@Component({
  selector: 'nk-file-path-link',
  imports: [AsyncPipe],
  templateUrl: './file-path-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilePathLinkComponent {
  public filePathWithoutSession = input.required<string>();
  public filePrefix = input<string | undefined>(undefined);
  public bucketName = input('general');
  public label = input('');
  public andClass = input('');
  public disabled = input(false);
  public includeIcon = input(true);
  public fileUrls = computed(() => {
    const filePathWithoutSession = this.filePathWithoutSession();
    const filePrefix = this.filePrefix();
    const bucketName = this.bucketName();

    if (filePathWithoutSession) {
      return this._fileService.getFullFilePathsForFiles([filePathWithoutSession], filePrefix, bucketName);
    }
    return of([]);
  });
  private _fileService = inject(FILE_API_SERVICE_TOKEN);
}
